// extracted by mini-css-extract-plugin
module.exports = {"container":"Register_container_FmmFy","dropArea":"Register_dropArea_18oWV","result":"Register_result_2hbWv","resultTable":"Register_resultTable_4x_kU"};